import { residentialSettingsAPI } from "./api";
import instance from "@/services/api";
import { toValidComponentDate } from "@/_helpers";
import {
  getAsrDocumentTitle,
  isProjectTypeDirty,
} from "@/constants";

/** ЖК со старым сценарием: список вызовов с этажом и блоком, без выбора диапазона этажей в форме АСР. */
export const ASR_CREATE_PICK_CALL_LEGACY_RESIDENT_IDS = [1515];

export const residentSettingsBlockNames = {
  M__ProjectFormInfoTab: "residentInfo",
  EntranceSchema: "EntranceSchema",
  M__ProjectFormSmetaTab: "ProjectSmetaTabs",
  M__ProjectFormMaterialTab: "MaterialRequests",
  M__ProjectFormRemontCostTab: "ResidentialPayments",
  M__ProjectFormDocumentTab: "EntranceDocuments",
  M__ProjectFormGeodesistCallTab: "GeodesistCallsBlock",
  M__ProjectFormStagesTab: "Stages",
  M__ProjectFormCertificate: "Certificates",
  M__ProjectFormMaterialRealizeTab: "MaterialRealizes",
  M__ProjectFormReconciliationTab: "Reconciliation",
  InvoiceApprovalConfigTab: "InvoiceApprovalConfig",
};

export const getDocuments = async (project_id) => {
  try {
    const res = await residentialSettingsAPI.getDocuments(project_id);
    if (res?.status && res?.data) {
      return res.data;
    }
    return res?.data || [];
  } catch (e) {}
};
export const signDocument = async (body, params = {}) => {
  try {
    const res = await residentialSettingsAPI.signDocument(body, params);
    return res?.data ?? res;
  } catch (e) {}
};
export const downloadDocumentPDF = async (project_agreement_id) => {
  const { downloadFile } = await import("@/services");
  const url = `/project/agreement/sign/download/`;
  const fileName = "Документ";
  await downloadFile(
    url,
    fileName,
    { project_agreement_id },
    "pdf",
    "post",
    true
  );
};
export const getResidentList = async () => {
  try {
    const res = await residentialSettingsAPI.getResidentials();
    return res?.data || [];
  } catch (e) {}
};
export const getProjectTypes = async (resident_id) => {
  const params = { resident_id };
  try {
    const res = await residentialSettingsAPI.getProjectTypes(params);
    return res?.data || [];
  } catch (e) {}
};
export const getIsShowAllTab = async (params) => {
  try {
    const res = await residentialSettingsAPI.getIsShowAllTab(params);
    const data = res?.data;

    if (typeof data === 'boolean') {
      return {
        showAllTabs: data,
        showInfoAndMaterialsOnly: false,
      };
    }

    return {
      showAllTabs: !!data?.show_all_tabs,
      showInfoAndMaterialsOnly: !!data?.show_info_and_materials_only,
    };
  } catch (e) {
    return {
      showAllTabs: false,
      showInfoAndMaterialsOnly: false,
    };
  }
};

export const getSessionProjectAssigns = async (project_id) => {
  if (project_id == null || project_id === "") return [];
  try {
    const res = await residentialSettingsAPI.getSessionProjectAssigns(project_id);
    return res?.data ?? [];
  } catch (e) {
    return [];
  }
};

export const getResidentialEntrances = async (params) => {
  try {
    const res = await residentialSettingsAPI.getEntrances(params);
    const entrances = (
      res?.data?.map((item) => ({
        ...item,
        entrance_name: `Подъезд ${item.entrance}${
          item.block_name ? `, Блок №${item.block_name}` : ""
        }`,
        entrance_full_name: `Подъезд ${item.entrance}${
          item.block_name ? `, Блок №${item.block_name}` : ""
        }${item.contractor_name ? `, ${item.contractor_name}` : ""} (${
          item.entrance_percent || 0
        }%)`,
      })) || []
    );
    return entrances;
  } catch (e) {}
};
export const getEntranceApartments = async (params) => {
  try {
    const res = await residentialSettingsAPI.getEntranceApartments(params);
    if (!res) return;
    return { ...res, data: res?.data?.reverse() || [] };
  } catch (e) {}
};
export const getFloorMapHeaderInfo = async (floor_map_id) => {
  try {
    const res = await residentialSettingsAPI.getFloorMapHeaderInfo(
      floor_map_id
    );
    if (!res) return null;

    // Формируем entrance_name и entrance_full_name
    const entrance_name = `Подъезд ${res.entrance}${
      res.block_name ? `, ${res.block_name}` : ""
    }`;
    const entrance_full_name = `Подъезд ${res.entrance}${
      res.block_name ? `, ${res.block_name}` : ""
    }${res.contractor_name ? `, ${res.contractor_name}` : ""}`;

    return {
      ...res,
      floor: res.level_num,
      entrance_name,
      entrance_full_name,
    };
  } catch (e) {
    console.error("Error loading floor map header info:", e);
    return null;
  }
};
export const getEntranceWorkSets = async (params) => {
  try {
    const res = await residentialSettingsAPI.getEntranceWorkSets(params);
    if (!res) return;
    return res?.data?.map((type) => {
      return {
        ...type,
        percent: type.placement_percent,
        label: `${type.placement_type_name} (${type.placement_percent || 0}%)`,
        children: type.work_set_check_groups?.map((group) => {
          return {
            ...group,
            percent: group.work_set_check_group_percent,
            label: `${group.work_set_check_group_name} (${
              group.work_set_check_group_percent || 0
            }%)`,
          };
        }),
      };
    });
  } catch (e) {}
};
export const getFloorTabs = async () => {
  try {
    const res = await residentialSettingsAPI.getFloorTabs();
    return res?.tabulations?.filter(
      (item) =>
        item.grant_code !== "M__ProjectFormMobileFloorMap" &&
        item.grant_code !== "M__ProjectFormMobileAgreement" &&
        item.grant_code !== "M__ProjectFormMobileOkk"
    );
  } catch (e) {}
};
export const getFloorProjectInfo = async (projectId) => {
  try {
    const res = await residentialSettingsAPI.getFloorProjectInfo(projectId);
    return res;
  } catch (e) {}
};
export const sendAgreementTo1C = async (
  projectId,
  contractor_agreement_list_id
) => {
  try {
    const res = await residentialSettingsAPI.sendAgreementTo1C(projectId, {
      contractor_agreement_list_id,
    });
    return res?.data;
  } catch (e) {}
};
export const sendDocumentAvrTo1C = async (
  floor_map_document_id,
  params = {}
) => {
  try {
    const res = await residentialSettingsAPI.sendDocumentAvrTo1C(
      floor_map_document_id,
      params
    );
    return res?.data;
  } catch (e) {}
};
export const getIsProjectSBS = async (projectId) => {
  try {
    const res = await residentialSettingsAPI.getIsProjectSBS(projectId);
    return res;
  } catch (e) {}
};

const floorSchemaDataRefactor = (res) => {
  const flatColors = {};
  if (res?.data?.length)
    res.data?.forEach((item) => {
      if (!flatColors[item.floor_flat_id]) {
        const flatColorsLength = Object.keys(flatColors).length;
        flatColors[item.floor_flat_id] = borderColors[flatColorsLength];
      }
    });
  const lines = res?.data?.filter((item) => item.coord_type !== "POINT");
  const circles = res?.data?.filter((item) => item.coord_type === "POINT");
  const texts = res?.data?.filter(
    (item) => !!item.frame_name && item.center_point
  );
  return {
    ...res,
    data: !!res?.data?.length,
    flatColors,
    lines,
    circles,
    texts,
  };
};
export const getFloorSchema = async (floor_map_id) => {
  try {
    const res = await residentialSettingsAPI.getFloorSchema(floor_map_id);
    if (!res) return;
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};
export const getFloorMaterials = async (floor_map_id) => {
  try {
    const res = await residentialSettingsAPI.getFloorMaterials(floor_map_id);
    return res;
  } catch (e) {}
};
export const getSchemaObjectInfo = async (floor_param_id, project_type_id) => {
  if (!floor_param_id) return;
  const params = { floor_param_id, project_type_id };
  try {
    const res = await residentialSettingsAPI.getObjectInfo(params);
    return res || null;
  } catch (e) {}
};
export const getFloorParamTypes = async () => {
  try {
    const res = await residentialSettingsAPI.getFloorParamTypes();
    return res?.data;
  } catch (e) {}
};
export const getFloorWorkSets = async (floor_map_id, params = {}) => {
  try {
    const res = await residentialSettingsAPI.getFloorWorkSets(floor_map_id, params);
    return res;
  } catch (e) {}
};

/** Строки работ для стяжки (EXEC_LIST / PROJECT_SCREED) с разбиением типов как в exec_list_screed_group_info_get. */
export const getExecListScreedPlacementRows = async (floor_map_id, params = {}) => {
  try {
    const res = await residentialSettingsAPI.getExecListScreedPlacementRows(
      floor_map_id,
      params,
    );
    return res?.data
  } catch (e) {}
};
export const getFloorWorkSetsManager = async (floor_map_id) => {
  try {
    const res = await residentialSettingsAPI.getFloorWorkSetsManager(
      floor_map_id
    );
    return res;
  } catch (e) {}
};

export const getFloorWorkSetBreakdown = async (
  floor_map_id,
  project_id,
  placement_type_id,
  work_set_check_group_id
) => {
  try {
    const res = await residentialSettingsAPI.getFloorWorkSetBreakdown(
      floor_map_id,
      {
        project_id,
        placement_type_id,
        work_set_check_group_id,
      }
    );
    return res;
  } catch (e) {}
};
export const getFloorWorkSetParams = async (floor_map_id, work_set_id) => {
  try {
    const res = await residentialSettingsAPI.getFloorWorkSetParams(
      floor_map_id,
      work_set_id
    );
    return res?.data;
  } catch (e) {}
};
export const completeWorkSet = async (floor_map_id, body) => {
  try {
    const res = await residentialSettingsAPI.completeWorkSet(
      floor_map_id,
      body
    );
    return res;
  } catch (e) {}
};
/** @returns {{ text: string, code: 'certificate' | 'journal' } | null} */
export const stripCodeCertificateOrJournalPrefix = (raw) => {
  if (typeof raw !== "string") return null;
  const code = raw.startsWith("code[certificate")
    ? "certificate"
    : raw.startsWith("code[journal")
      ? "journal"
      : null;
  if (!code) {
    return null;
  }
  const end = raw.indexOf("]");
  if (end === -1) {
    return null;
  }
  const text = raw
    .slice(end + 1)
    .replace(/^[\s:,-]+/, "")
    .trim();
  return { text, code };
};

export const callOKK = async (floor_map_id, body, showErrorSnackbar) => {
  try {
    const res = await residentialSettingsAPI.callOKK(floor_map_id, body);
    return res || true;
  } catch (e) {
  }
};

export const validateExecListBeforeOkk = async (floor_map_id, params) => {
  try {
    const res = await residentialSettingsAPI.validateExecListBeforeOkk(
      floor_map_id,
      params
    );
    return res?.data ?? null;
  } catch (e) {}
};

export const createExecListDocument = async (floor_map_id, body, params = {}) => {
  try {
    const res = await residentialSettingsAPI.createExecListDocument(
      floor_map_id,
      body,
      params
    );
    return res?.data ?? null;
  } catch (e) {}
};

export const reformExecListDocument = async (floor_map_id, body, params = {}) => {
  try {
    const res = await residentialSettingsAPI.reformExecListDocument(
      floor_map_id,
      body,
      params
    );
    return res?.data ?? null;
  } catch (e) {}
};

export const createExecListManual = async (floor_map_id, body, params = {}) => {
  try {
    const res = await residentialSettingsAPI.createExecListManual(
      floor_map_id,
      body,
      params
    );
    return res?.data ?? null;
  } catch (e) {}
};

export const deleteOKKCall = async (body) => {
  try {
    const res = await residentialSettingsAPI.deleteOKKCall(body);
    return res;
  } catch (e) {}
};
export const checkCertificates = async (body) => {
  try {
    const res = await residentialSettingsAPI.checkCertificates(body);
    return res?.data ?? [];
  } catch (e) {
    return [];
  }
};
export const validateCall = async (params) => {
  try {
    const res = await residentialSettingsAPI.validateCall(params);
    const checks = Array.isArray(res?.data) ? res.data : [];
    return { success: true, checks };
  } catch (e) {
    const msg =
      e?.response?.data?.message ||
      e?.response?.data?.error ||
      (typeof e?.response?.data === "string" ? e.response.data : null) ||
      e?.message ||
      "Ошибка проверок перед вызовом";
    return { success: false, checks: [], message: String(msg) };
  }
};

export const getPreNuCallInfo = async (body) => {
  try {
    const res = await residentialSettingsAPI.getPreNuCallInfo(body);
    return Array.isArray(res?.data) ? res.data : [];
  } catch (e) {
    return [];
  }
};

export const createAsrPreCall = async (body, params = {}) => {
  try {
    return await residentialSettingsAPI.createAsrPreCall(body, params);
  } catch (e) {
    return null;
  }
};

export const getLastAsrPreCall = async (floorMapId, params = {}) => {
  if (floorMapId == null || floorMapId === "") return null;
  try {
    const res = await residentialSettingsAPI.getLastAsrPreCall(
      floorMapId,
      params,
    );
    return res?.data ?? null;
  } catch (e) {
    return null;
  }
};

export const getCheckedCallsForAsr = async (params = {}) => {
  try {
    const res = await residentialSettingsAPI.getCheckedCallsForAsr(params);
    return Array.isArray(res?.data) ? res.data : [];
  } catch (e) {
    return [];
  }
};

export const getCheckedCallsForExecList = async (params = {}) => {
  try {
    const res = await residentialSettingsAPI.getCheckedCallsForExecList(params);
    return Array.isArray(res?.data) ? res.data : [];
  } catch (e) {
    return [];
  }
};

export const getLastAsrForContractor = async (params = {}) => {
  if (!params?.resident_id || !params?.contractor_id) return null;
  try {
    const res = await residentialSettingsAPI.getLastAsrForContractor(params);
    return res?.data ?? null;
  } catch (e) {
    return null;
  }
};

export const getAsrDocInfo = async (floor_map_document_id) => {
  if (floor_map_document_id == null || floor_map_document_id === "")
    return null;
  try {
    const res = await residentialSettingsAPI.getAsrDocInfo({
      floor_map_document_id,
    });
    return res?.data ?? null;
  } catch (e) {
    return null;
  }
};

export const createAsrManual = async (body, params = {}) => {
  try {
    const res = await residentialSettingsAPI.createAsrManual(body, params);
    return res?.data ?? null;
  } catch (e) {
    return null;
  }
};

export const reformAsrManual = async (body, params = {}) => {
  try {
    const res = await residentialSettingsAPI.reformAsrManual(body, params);
    return res?.data ?? null;
  } catch (e) {
    return null;
  }
};

export const getAcceptanceProcessStatus = async (params) => {
  try {
    const res = await residentialSettingsAPI.getAcceptanceProcessStatus(params);
    const rows = Array.isArray(res?.data) ? res.data : [];
    return { success: true, rows };
  } catch (e) {
    const msg =
      e?.response?.data?.message ||
      e?.response?.data?.error ||
      (typeof e?.response?.data === "string" ? e.response.data : null) ||
      e?.message ||
      "Ошибка загрузки статуса процесса";
    return { success: false, rows: [], message: String(msg) };
  }
};

export const getFloorMapAcceptanceCode = async (floor_map_id) => {
  if (floor_map_id == null || floor_map_id === "") return null;
  try {
    const res = await residentialSettingsAPI.getFloorMapAcceptanceCode(
      floor_map_id,
    );
    if (!res) return null;
    return res?.data ?? null;
  } catch (e) {
    return null;
  }
};

/** Строки validate, при которых вызов (НУ/ДТН/ИТР и т.д.) блокируется */
export const getBlockingCallChecks = (checks) => {
  if (!Array.isArray(checks)) return [];
  return checks.filter((row) => {
    if (!row || typeof row !== "object") return false;
    const isBlockCall = row.is_block_call;
    return isBlockCall === true || isBlockCall === "t" || isBlockCall === 1;
  });
};

/** Короткая подпись для UI/уведомлений (список материалов — в подсказке или «Список») */
export const shortenCallCheckMessage = (row) => {
  if (!row || typeof row !== "object") return "";
  if (row.check_code === "CERTIFICATES_MISSING") {
    return "Не загружены сертификаты";
  }
  return (row.check_message || row.message || row.check_code || "").trim();
};

export const formatBlockingCallMessages = (blockingRows) => {
  if (!blockingRows?.length) return "";
  return blockingRows
    .map((row) => shortenCallCheckMessage(row))
    .filter(Boolean)
    .join("\n");
};
export const updateFloorParam = async (body, params) => {
  try {
    const res = await residentialSettingsAPI.updateFloorParam(body, params);
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};
export const updateFloorMapLine = async (body) => {
  try {
    const res = await residentialSettingsAPI.updateFloorMapLine(body);
    return res;
  } catch (e) {}
};
export const deleteFloorMapLine = async (floor_param_id, params = {}) => {
  if (!floor_param_id) return;
  try {
    const res = await residentialSettingsAPI.deleteFloorMapLine(
      floor_param_id,
      params
    );
    return floorSchemaDataRefactor(res);
  } catch (e) {}
};

export const getEntranceMaterials = async (params) => {
  if (params?.sbs_project_id == null) return [];
  try {
    const res = await residentialSettingsAPI.getEntranceMaterials(params);
    return res?.data;
  } catch (e) {}
};
export const getEntranceMaterialRequests = async (params) => {
  try {
    const res = await residentialSettingsAPI.getEntranceMaterialRequests(
      params
    );
    return res?.data;
  } catch (e) {}
};
export const getProviderRequestInvoices = async (provider_request_id) => {
  try {
    const res = await residentialSettingsAPI.getProviderRequestInvoices(
      provider_request_id
    );
    return res?.data || [];
  } catch (e) {
    return [];
  }
};
export const getRealizes = async (params) => {
  try {
    const res = await residentialSettingsAPI.getRealizes(params);
    return res?.data;
  } catch (e) {
    console.error("Ошибка загрузки реализаций:", e);
    return [];
  }
};

export const getRealizeItems = async (params) => {
  try {
    const res = await residentialSettingsAPI.getRealizeItems(params);
    return res?.data;
  } catch (e) {
    console.error("Ошибка загрузки позиций реализации:", e);
    return [];
  }
};
export const deleteEntranceMaterialRequest = async (
  filters,
  provider_request_item_id
) => {
  const params = { ...filters, provider_request_item_id };
  try {
    const res = await residentialSettingsAPI.deleteEntranceMaterialRequest(
      params
    );
    return res?.data;
  } catch (e) {}
};

export const updateEntranceMaterialRequestQty = async (
  filters,
  provider_request_item_id,
  material_cnt
) => {
  const params = { ...filters };
  const body = { provider_request_item_id, material_cnt };
  const res = await residentialSettingsAPI.updateProviderRequestItemQty(body, params);
  return res?.data;
};
export const sendInvoiceTo1C = async (
  provider_request_invoice_id,
  targetSystem = null
) => {
  try {
    const res = await residentialSettingsAPI.sendInvoiceTo1C(
      provider_request_invoice_id,
      targetSystem
    );
    return res?.data;
  } catch (e) {
    throw e;
  }
};
export const signInvoice = async (provider_request_invoice_id, signerType) => {
  try {
    const res = await residentialSettingsAPI.signInvoice(
      provider_request_invoice_id,
      signerType
    );
    return res; // res уже содержит {sign_url, status, error}
  } catch (e) {
    throw e;
  }
};
export const downloadInvoice = async (
  provider_request_invoice_id,
  invoice_num
) => {
  try {
    const response = await residentialSettingsAPI.downloadInvoice(
      provider_request_invoice_id
    );
    const { saveAs } = await import("file-saver");
    const blob = new Blob([response.data], { type: "application/pdf" });
    const filename = `Накладная №${
      invoice_num || provider_request_invoice_id
    }.pdf`;
    saveAs(blob, filename);
    return true;
  } catch (e) {
    throw e;
  }
};

export const downloadRealize = async (realize_id, realize_num) => {
  try {
    const response = await residentialSettingsAPI.downloadRealize(realize_id);
    const { saveAs } = await import("file-saver");
    const blob = new Blob([response.data], { type: "application/pdf" });
    const filename = `Реализация №${realize_num || realize_id}.pdf`;
    saveAs(blob, filename);
    return true;
  } catch (e) {
    throw e;
  }
};
export const signRealize = async (realize_id) => {
  try {
    const res = await residentialSettingsAPI.signRealize(realize_id);
    return res; // res содержит {sign_url, status, error}
  } catch (e) {
    throw e;
  }
};
export const sendRealizeTo1C = async (realize_id) => {
  try {
    const res = await residentialSettingsAPI.sendRealizeTo1C(realize_id);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

const parseDateToTimestamp = (dateStr) => {
  if (!dateStr) return 0;
  if (typeof dateStr !== 'string') return new Date(dateStr).getTime() || 0;
  if (dateStr.includes('.')) {
    const parts = dateStr.trim().split('.');
    if (parts.length >= 3) {
      const [d, m, y] = parts;
      const date = new Date(Number(y), Number(m) - 1, Number(d));
      return isNaN(date.getTime()) ? 0 : date.getTime();
    }
  }
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? 0 : date.getTime();
};

export const getPlanFactPaymentReport = async (params) => {
  return await residentialSettingsAPI.getPlanFactPaymentReport(params);
};

export const getOperFactBkCompareReport = async (params) => {
  return await residentialSettingsAPI.getOperFactBkCompareReport(params);
};

export const exportOperFactBkCompareReport = async (params) => {
  return await residentialSettingsAPI.exportOperFactBkCompareReport(params);
};

export const getSbsInagroKonstruktivByResident = async (resident_id) => {
  try {
    const res = await residentialSettingsAPI.getSbsInagroKonstruktivByResident({
      resident_id,
    });
    return res?.data || [];
  } catch (e) {
    return null;
  }
};

export const getResourceStatementReport = async (params) => {
  return await residentialSettingsAPI.getResourceStatementReport(params);
};

export const exportResourceStatementReport = async (params) => {
  return await residentialSettingsAPI.exportResourceStatementReport(params);
};

export const getResourceRemainderReport = async (params) => {
  return await residentialSettingsAPI.getResourceRemainderReport(params);
};

export const exportResourceRemainderReport = async (params) => {
  return await residentialSettingsAPI.exportResourceRemainderReport(params);
};

export const getOrderedVsM19Report = async (params) => {
  return await residentialSettingsAPI.getOrderedVsM19Report(params);
};

export const exportOrderedVsM19Report = async (params) => {
  return await residentialSettingsAPI.exportOrderedVsM19Report(params);
};

export const getPriceVarianceReport = async (params) => {
  try {
    const res = await residentialSettingsAPI.getPriceVarianceReport(params);
    return res?.data ?? res ?? null;
  } catch (e) {
    return null;
  }
};

export const exportPriceVarianceReport = async (params) => {
  try {
    return await residentialSettingsAPI.exportPriceVarianceReport(params);
  } catch (e) {
    return null;
  }
};

export const getPriceVarianceFilters = async () => {
  try {
    const res = await residentialSettingsAPI.getPriceVarianceFilters();
    const payload = res?.data ?? res ?? {};
    return {
      biznesRegions: payload.biznes_regions || [],
      sbsProjects: (payload.sbs_projects || []).map((p) => ({
        ...p,
        sbs_project_id: p.sbs_project_id != null ? Number(p.sbs_project_id) : p.sbs_project_id,
        sbs_project_name: p.sbs_project_name || p.naimenovanie || String(p.sbs_project_id ?? ''),
      })),
    };
  } catch (e) {
    return { biznesRegions: [], sbsProjects: [] };
  }
};

export const getResourceStatementFloors = async (project_entrance_id) => {
  try {
    const res = await residentialSettingsAPI.getResourceStatementFloors({ project_entrance_id });
    return (res?.data || []).map((f) => ({
      ...f,
      floor_name: `Этаж ${f.level_num}`,
    }));
  } catch (e) {
    return [];
  }
};

export const getResourceStatementProjectTypes = async (resident_id) => {
  try {
    const res = await residentialSettingsAPI.getResourceStatementProjectTypes({ resident_id });
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getResourceStatementResidents = async () => {
  try {
    const res = await residentialSettingsAPI.getResourceStatementResidents();
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getResourceStatementEntrances = async (resident_id) => {
  try {
    const res = await residentialSettingsAPI.getResourceStatementEntrances({ resident_id });
    return (res?.data || []).map((e) => ({
      ...e,
      entrance_name: `Подъезд ${e.entrance}`,
    }));
  } catch (e) {
    return [];
  }
};

export const getResourceStatementFloorsByResident = async (resident_id) => {
  try {
    const res = await residentialSettingsAPI.getResourceStatementFloorsByResident({ resident_id });
    return (res?.data || []).map((f) => ({
      ...f,
      floor_name: `Этаж ${f.level_num}`,
    }));
  } catch (e) {
    return [];
  }
};

export const getContractorsList = async () => {
  try {
    const res = await residentialSettingsAPI.getContractorsList();
    return res?.contractors || [];
  } catch (e) {
    return [];
  }
};

export const getEntrancePayments = async (params) => {
  try {
    const res = await residentialSettingsAPI.getEntrancePayments(params);

    if(!res) return;

    let payments = [];
    let payment = null
    if(res.finance_payments?.length) payments = [...res.finance_payments];

    if(res.remont_costs?.length) {
      const errorItems = res.remont_costs.filter(
        (item) => item.current_status === "CREATE_ERROR" || item.current_status === "CREATE_ERROR_EXCEED"
      );
      const hasErrors = errorItems.length > 0;
      const rc = hasErrors ? errorItems[0] : res.remont_costs[0];

      const documentsById = new Map();
      (res.remont_costs || []).forEach((item) => {
        (item.documents || []).forEach((doc) => {
          if (doc?.floor_map_document_id != null && !documentsById.has(doc.floor_map_document_id)) {
            documentsById.set(doc.floor_map_document_id, doc);
          }
        });
      });
      const documents = documentsById.size > 0 ? Array.from(documentsById.values()) : undefined;

      const hasDocsNotSigned = res.remont_costs.some(
        (item) => item.create_error_code === "ERR_DOCS_NOT_SIGNED" && (item.documents || []).length > 0
      );

      const createErrorByCode = new Map();
      (res.remont_costs || []).forEach((item) => {
        const list = Array.isArray(item.create_error) ? item.create_error : [];
        list.forEach((e) => {
          if (e && typeof e === "object" && (e.error_code != null || e.error_desc != null)) {
            const key = e.error_code ?? e.error_desc ?? "";
            if (key && !createErrorByCode.has(key)) {
              createErrorByCode.set(key, { error_code: e.error_code ?? "", error_desc: e.error_desc ?? "" });
            } else if(key && createErrorByCode.has(key) && e.documents?.length) {
              const documents = Array.isArray(e.documents) ? e.documents : [];
              let list = createErrorByCode.get(key).documents || [];
              documents.forEach((doc) => {
                if (!list.some((d) => d.floor_map_document_id === doc.floor_map_document_id)) {
                  list.push(doc);
                }
              });
              createErrorByCode.set(key, {...createErrorByCode.get(key), documents: list});
            }
          }
        });
      });
      const create_error = createErrorByCode.size > 0 ? Array.from(createErrorByCode.values()) : undefined;

      const remont_costsWithUniqueDocs = (res.remont_costs || []).map((item) => {
        const docById = new Map();
        (item.documents || []).forEach((doc) => {
          if (doc?.floor_map_document_id != null && !docById.has(doc.floor_map_document_id)) {
            docById.set(doc.floor_map_document_id, doc);
          }
        });
        const uniqueDocuments = docById.size > 0 ? Array.from(docById.values()) : undefined;
        return { ...item, documents: uniqueDocuments };
      });

      payment = {
        finance_payment_id: new Date().getTime(),
        date_payment: rc?.date_create,
        fp_payment_amount: res.remont_costs?.reduce((sum, item) => sum + item.payment_amount, 0) || 0,
        responsible: rc?.responsible,
        current_status: rc?.current_status,
        current_status_name: rc?.current_status_name,
        status_desc: rc?.status_desc,
        status_code: rc?.status_code,
        remont_costs: remont_costsWithUniqueDocs,
        isGroup: true,
        ...(documents?.length ? { documents } : {}),
        ...(hasDocsNotSigned ? { create_error_code: "ERR_DOCS_NOT_SIGNED" } : {}),
        ...(create_error?.length ? { create_error } : {}),
      };
    }

    const remont_costs_paid_by_avance = res?.remont_costs_paid_by_avance?.map(item => {
      return {
        ...item,
        isPaidByAvance: true,
        finance_payment_id: `remont_costs_paid_by_avance_${item.remont_costs_id}`,
        remont_costs: [item]
      }
    })

    if(remont_costs_paid_by_avance?.length) 
      payments = [...remont_costs_paid_by_avance, ...payments];

    if(payment) payments = [payment, ...payments];

    payments = [...payments]
      .sort((a, b) => {
        const aPaid = (a.current_status || '').toUpperCase() === 'PAYED';
        const bPaid = (b.current_status || '').toUpperCase() === 'PAYED';
        if (aPaid && !bPaid) return 1;
        if (!aPaid && bPaid) return -1;
        const dateA = parseDateToTimestamp(a.date_create || a.date_payment);
        const dateB = parseDateToTimestamp(b.date_create || b.date_payment);
        return dateB - dateA;
      })
      
    return {
      ...res,
      payments,
    };
  } catch (e) {}
};
export const getEntranceStages = async (params = {}) => {
  try {
    const res = await residentialSettingsAPI.getEntranceStages(params);
    return res?.data;
  } catch (e) {}
};
export const getEntranceDocumentFloors = async (params) => {
  try {
    const res = await residentialSettingsAPI.getEntranceDocumentFloors(params);
    return (
      res?.data?.map((item) => ({
        ...item,
        floor_name: `Этаж ${item.floor}`,
      })) || []
    );
  } catch (e) {}
};
export const getEntranceDocumentTypes = async () => {
  try {
    const res = await residentialSettingsAPI.getEntranceDocumentTypes();
    return res?.data;
  } catch (e) {}
};
export const getPlacementTypes = async () => {
  try {
    const res = await residentialSettingsAPI.getPlacementTypes();
    return res?.data;
  } catch (e) {}
};
export const createEntranceMaterialRequest = async (body, params) => {
  if (params?.sbs_project_id == null) return null;
  try {
    const res = await residentialSettingsAPI.createEntranceMaterialRequest(
      body,
      params
    );
    return res?.data;
  } catch (e) {}
};

// Использовать там, где нужно НЕ скрывать ошибку (например, в bulk-форме)
export const createEntranceMaterialRequestOrThrow = async (body, params) => {
  if (params?.sbs_project_id == null) {
    throw new Error("Не указан проект УСП (sbs_project_id)");
  }

  // Важно: throwError=true, чтобы наружу прилетал объект ошибки (нужно для строки в bulk-таблице),
  // а showToast=true оставляет стандартный toast внизу.
  const res = await instance(true, null, { throwError: true, showToast: true })
    .post(`/project/provider_requests/create/`, body, { params })
    .then((r) => r?.data);

  if (res?.status === false) {
    throw new Error(res?.message || "Ошибка создания заявки на материал");
  }
  return res?.data ?? res;
};
export const getContractorAgreementsByMaterial = async (
  material_id,
  sbs_project_id
) => {
  if (sbs_project_id == null) return [];
  try {
    const params = { material_id, sbs_project_id };
    const res = await residentialSettingsAPI.getContractorAgreementsByMaterial(params);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getContractorAgreementsBySbsProject = async (sbs_project_id) => {
  if (sbs_project_id == null) return [];
  try {
    const res = await residentialSettingsAPI.getContractorAgreementsBySbsProject({ sbs_project_id });
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getMaterialPriceByAgreement = async (contractor_agreement_list_id, material_id) => {
  try {
    const params = { contractor_agreement_list_id, material_id };
    const res = await residentialSettingsAPI.getMaterialPriceByAgreement(params);
    return res?.data?.price ?? null;
  } catch (e) {
    return null;
  }
};

export const getMaterialsByAgreement = async (sbs_project_id, project_type_id) => {
  if (!sbs_project_id) return [];
  try {
    const params = { sbs_project_id, project_type_id };
    const res = await residentialSettingsAPI.getMaterialsByAgreement(params);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

/** Подпись типа документа в таблице и в имени скачиваемого PDF (только фронт). */
export function resolveFloorMapDocumentDisplayName(row, options = {}) {
  const base = String(row?.floor_map_document_type_name || "").trim();
  if (!base) return "";

  const typeCode = row?.floor_map_document_type_code;
  const projectTypeCode =
    options.projectTypeCode ?? row?.project_type_code ?? null;
  const projectTypeId =
    options.projectTypeId != null && options.projectTypeId !== ""
      ? Number(options.projectTypeId)
      : null;

  const isDirtyProject = isProjectTypeDirty(projectTypeCode, projectTypeId);

  if (typeCode !== "ASR" || !isDirtyProject) {
    return base;
  }

  const numSuffixMatch = base.match(/(\s*\(№[^)]*\))\s*$/);
  const numSuffix = numSuffixMatch ? numSuffixMatch[1] : "";
  return `${getAsrDocumentTitle(projectTypeCode, projectTypeId)}${numSuffix}`;
}

export const getEntranceDocuments = async (params, signal) => {
  try {
    const res = await residentialSettingsAPI.getEntranceDocuments(params, signal);
    return res?.data?.map((item) => ({
      ...item,
      _showSigns: !item.is_signed,
    }));
  } catch (e) {}
};

export const getDocumentAsrCertificates = async (floor_map_document_id) => {
  try {
    const res = await residentialSettingsAPI.getDocumentAsrCertificates({
      floor_map_document_id,
    });
    return res?.data?.certificate_urls || [];
  } catch (e) {
    return null;
  }
};

export const getEntranceDocumentsPreCallPto = async (params) => {
  try {
    const res = await residentialSettingsAPI.getEntranceDocumentsPreCallPto(params);
    return res?.data || [];
  } catch (e) {}
};

export const getEngineerPtoAssignmentsRead = async () => {
  try {
    const res = await residentialSettingsAPI.getEngineerPtoAssignmentsRead();
    return res?.data || [];
  } catch (e) {}
};

export const getPtoDocumentsSessionRead = async (params) => {
  try {
    const res = await residentialSettingsAPI.getPtoDocumentsSessionRead(params);
    return res?.data || [];
  } catch (e) {}
};

export const acceptPtoDocumentsSession = async (body) => {
  try {
    const res = await residentialSettingsAPI.acceptPtoDocumentsSession(body);
    return res;
  } catch (e) {}
};
export const changeDateEntranceDocument = async (body, params) => {
  try {
    const res = await residentialSettingsAPI.changeDateEntranceDocument(
      body,
      params
    );
    return res?.data;
  } catch (e) {}
};
export const signEntranceDocument = async (body, params) => {
  try {
    const res = await residentialSettingsAPI.signEntranceDocument(body, params);
    return res?.data;
  } catch (e) {}
};

export const signM19OverDocument = async (body, params) => {
  try {
    const res = await residentialSettingsAPI.signM19OverDocument(body, params);
    return res?.data;
  } catch (e) {}
};
export const getFloorMapPoints = async (floor_map_id, params) => {
  try {
    const res = await residentialSettingsAPI.getFloorMapPoints(
      floor_map_id,
      params
    );
    return res?.data;
  } catch (e) {}
};
export const getFloorMapPointInfo = async (
  floor_map_id,
  call_check_list_point_id
) => {
  try {
    const res = await residentialSettingsAPI.getFloorMapPointInfo(
      floor_map_id,
      call_check_list_point_id
    );
    return res?.data;
  } catch (e) {}
};
export const getFloorMapChecks = async (floor_map_id, params) => {
  try {
    const res = await residentialSettingsAPI.getFloorMapChecks(
      floor_map_id,
      params
    );
    return res?.data?.map((item, i) => ({ ...item, index: i + 1 }));
  } catch (e) {}
};
export const getFloorOpenspace = async (floor_map_id) => {
  try {
    const res = await residentialSettingsAPI.getFloorOpenspace(floor_map_id);
    return (
      res?.data?.map((item, i) => ({
        ...item,
        openspace_name: `Openspace ${i + 1}`,
      })) || []
    );
  } catch (e) {}
};

export const getSkladOptions = async (params) => {
  try {
    const res = await residentialSettingsAPI.getSkladOptions(params);
    return res?.data;
  } catch (e) {}
};

export const getPurchaseTypes = async () => {
  try {
    const res = await residentialSettingsAPI.getPurchaseTypes();
    return res?.data;
  } catch (e) {}
};

export const getInitiatorTypes = async () => {
  try {
    const res = await residentialSettingsAPI.getInitiatorTypes();
    return res?.data;
  } catch (e) {}
};

export const flattenPoints = (pointsArray) => {
  if (!pointsArray || !Array.isArray(pointsArray)) {
    return [];
  }
  return pointsArray.reduce((acc, [x, y]) => {
    acc.push(x, y);
    return acc;
  }, []);
};

export const checkFlatFloor = (floor, apartment, addData, isSubmit = false) => {
  if (Number(addData?.flat_num) === Number(apartment.flat_num))
    return !isSubmit;
  if (floor.is_selected) {
    const floorsOffset = Number(addData?.floor) - Number(floor.floor);
    const direction = floorsOffset > 0 ? 1 : -1;
    const offset = Math.abs(floorsOffset);
    const flatNum =
      direction === 1
        ? Number(addData?.flat_num) - offset * addData?.floorFlatLength
        : Number(addData?.flat_num) + offset * addData?.floorFlatLength;
    if (flatNum === Number(apartment.flat_num)) return true;
  }
  return false;
};

export const borderColors = [
  "#FF5733",
  "#33FF57",
  "#3357FF",
  "#FF33A1",
  "#A133FF",
  "#33FFF5",
  "#F5FF33",
  "#FF8C33",
  "#33FF8C",
  "#8C33FF",
  "#FF3333",
  "#33FF33",
  "#3333FF",
  "#FF33FF",
  "#33FFFF",
  "#FF9933",
  "#33FF99",
  "#9933FF",
  "#FF3399",
  "#3399FF",
];

export const onKonvaWheel = (e, stage) => {
  if (!stage) return;
  e.evt.preventDefault();
  // "коэффициент" скорости масштабирования
  const scaleBy = 1.15;

  // Текущий масштаб
  const oldScale = stage.scaleX();

  // Позиция курсора внутри Stage
  const pointer = stage.getPointerPosition();

  // Находим, «куда» будет масштабироваться сцена
  const mousePointTo = {
    x: (pointer.x - stage.x()) / oldScale,
    y: (pointer.y - stage.y()) / oldScale,
  };

  // Определяем направление (deltaY > 0 – отдаление, < 0 – приближение)
  const direction = e.evt.deltaY > 0 ? -1 : 1;

  // Считаем новый масштаб
  const newScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;

  // Устанавливаем масштаб
  stage.scale({ x: newScale, y: newScale });

  // Рассчитываем сдвиг так, чтобы точка под курсором «осталась на месте»
  const newPos = {
    x: pointer.x - mousePointTo.x * newScale,
    y: pointer.y - mousePointTo.y * newScale,
  };
  stage.position(newPos);
  stage.batchDraw();
};

export const frameColumns = [
  {
    name: "frame_param_type_name",
    label: "Параметр",
    field: "frame_param_type_name",
    align: "left",
  },
  {
    name: "param_value",
    label: "Значение",
    field: "param_value",
    align: "right",
  },
];

export const workStatuses = {
  empty: "empty",
  full: "full",
  half: "half",
};

export const materialRequestColumns = [
  {
    name: "material_name",
    label: "Материал",
    field: "material_name",
    align: "left",
  },
  {
    name: "request_info",
    label: "Информация",
    align: "left",
    style: "min-width: 180px",
  },
  {
    name: "qty",
    label: "Количество",
    align: "right",
  },
  {
    name: "unshipped_cnt",
    label: "Неотгружено",
    align: "right",
  },
  {
    name: "price",
    label: "Цена",
    field: "price",
    align: "right",
  },
  {
    name: "material_sum",
    label: "Сумма",
    field: "material_sum",
    align: "right",
  },
  {
    name: "dates",
    label: "Даты",
    align: "center",
  },
  {
    name: "provider_request_status_name",
    label: "Статус",
    field: "provider_request_status_name",
    align: "left",
  },
  {
    name: "invoices",
    label: "Накладные",
    align: "center",
  },
  {
    name: "download",
    label: "Скачать",
    align: "center",
  },
];
export const materialRequestsColumnsSmall = [
  {
    name: "material_name",
    label: "Материал",
    field: "material_name",
    align: "left",
  },
  {
    name: "material_cnt",
    label: "Кол-во",
    field: "material_cnt",
    align: "right",
  },
  {
    name: "material_sum",
    label: "Сумма, ₸",
    field: "material_sum",
    align: "right",
  },
];

// Date sorting helper using existing toValidComponentDate
const dateSort = (a, b) => {
  const ta = new Date(toValidComponentDate(a)).getTime() || 0;
  const tb = new Date(toValidComponentDate(b)).getTime() || 0;
  return ta - tb;
};
export const materialRequestsSumColumns = [
  {
    name: "total_sum",
    label: "Общая сумма, ₸",
    align: "right",
  },
  {
    name: "paid_sum",
    label: "Оплаченная сумма, ₸",
    align: "right",
  },
  {
    name: "processing_sum",
    label: "Ожидается оплата, ₸",
    align: "right",
  },
  {
    name: "remaining_sum",
    label: "Остаток, ₸",
    align: "right",
  },
];

export const workSetColumns = [
  {
    name: "work_set_name",
    label: "Конструктив",
    field: "work_set_name",
    align: "left",
  },
  {
    name: "material_name",
    label: "Материал",
    field: "material_name",
    align: "left",
  },
  {
    name: "material_amount",
    label: "Кол-во",
    field: "material_amount",
    align: "right",
  },
  {
    name: "material_sum",
    label: "Сумма, ₸",
    field: "material_sum",
    align: "right",
  },
];
export const entrancePaymentColumns = [
  {
    name: "remont_costs_id",
    label: "ID",
    field: "remont_costs_id",
    align: "center",
    sortable: true,
  },
  {
    name: "contragent",
    label: "Контрагент",
    field: "contragent",
    align: "left",
    sortable: true,
  },
  {
    name: "work_set_check_group_name",
    label: "Группа работ",
    field: "work_set_check_group_name",
    align: "left",
    sortable: true,
  },
  {
    name: "placement_type_name",
    label: "Тип",
    field: "placement_type_name",
    align: "left",
    sortable: true,
  },
  {
    name: "block_name",
    label: "Блок",
    field: "block_name",
    align: "left",
    sortable: true,
  },
  {
    name: "floor",
    label: "Этаж",
    field: "floor",
    align: "center",
    sortable: true,
  },
  {
    name: "col_sum",
    label: "Сумма работ, ₸",
    field: "col_sum",
    align: "right",
    sortable: true,
  },
  {
    name: "payment_amount",
    label: "Сумма платежа, ₸",
    field: "payment_amount",
    align: "right",
    sortable: true,
  },
  {
    name: "date_create",
    label: "Дата создания",
    field: "date_create",
    align: "center",
    sortable: true,
    sort: (a, b) => dateSort(a, b),
  },
  {
    name: "date_payment",
    label: "Дата платежа",
    field: "date_payment",
    align: "center",
    sortable: true,
    sort: (a, b) => dateSort(a, b),
  },
  {
    name: "is_reconciliation_payed",
    label: "Оплачено по акту сверки",
    field: "is_reconciliation_payed",
    align: "center",
    sortable: true,
  },
  {
    name: "reconciliation_status_name",
    label: "Статус",
    field: "reconciliation_status_name",
    align: "center",
    sortable: true,
  },
];
export const financePaymentColumns = [
  {
    name: "date_payment",
    label: "Дата создания платежа",
    field: "date_payment",
    align: "center",
  },
  {
    name: "bi_code",
    label: "Договор (1С код)",
    field: "bi_code",
    align: "left",
  },
  {
    name: "payment_sum",
    label: "Сумма платежа",
    field: "payment_sum",
    align: "right",
  },
  {
    name: "finance_payment_status_name",
    label: "Статус",
    field: "finance_payment_status_name",
    align: "center",
  },
];
export const entranceStagesColumns = [
  {
    name: "floor_map_id",
    label: "",
    align: "center",
  },
  {
    name: "block_name",
    label: "Блок",
    field: "block_name",
    align: "center",
    sortable: true,
  },
  {
    name: "floor",
    label: "Этаж",
    field: "floor",
    align: "center",
    sortable: true,
  },
  {
    name: "placement_type_name",
    label: "Тип",
    field: "placement_type_name",
    align: "left",
    sortable: true,
  },
  {
    name: "work_set_check_group_name",
    label: "Группа работ",
    field: "work_set_check_group_name",
    align: "left",
    sortable: true,
  },
  {
    name: "check_status",
    label: "Статус",
    field: "check_status",
    align: "center",
    sortable: true,
  },
  {
    name: "call_employee_fio",
    label: "Вызвал(а)",
    field: "call_employee_fio",
    align: "left",
    sortable: true,
  },
  {
    name: "call_date",
    label: "Дата вызова",
    field: "call_date",
    align: "center",
  },
  {
    name: "check_employee_fio",
    label: "Принял(а)",
    field: "check_employee_fio",
    align: "left",
    sortable: true,
  },
  {
    name: "check_date",
    label: "Дата принятия",
    field: "check_date",
    align: "center",
  },
];
export const entranceDocumentColumns = [
  {
    name: "floor_map_document_id",
    label: "ID",
    field: "floor_map_document_id",
    align: "center",
  },
  {
    name: "floor_map_document_type_name",
    label: "Тип документа",
    field: "floor_map_document_type_name",
    align: "left",
  },
  {
    name: "work_set_check_group_name",
    label: "Группа работ",
    field: "work_set_check_group_name",
    align: "left",
  },
  {
    name: "placement_type_name",
    label: "Тип",
    field: "placement_type_name",
    align: "left",
  },
  {
    name: "block_name",
    label: "Блок",
    field: "block_name",
    align: "center",
  },
  {
    name: "floor",
    label: "Этаж",
    field: "floor",
    align: "center",
  },
  {
    name: "avr_sum",
    label: "Сумма документа",
    field: "avr_sum",
    align: "right",
  },
  {
    name: "date_create",
    label: "Дата создания",
    field: "date_create",
    align: "center",
  },
  {
    name: "date_begin",
    label: "Дата выдачи сертификата",
    field: "date_begin",
    align: "center",
  },
  {
    name: "date_end",
    label: "Срок действия сертификата",
    field: "date_end",
    align: "center",
  },
  {
    name: "is_signed",
    label: "Статус",
    field: "is_signed",
    align: "center",
  },
  {
    name: "sign",
    label: "Подписать",
    align: "center",
  },
  {
    name: "download",
    label: "Документ",
    align: "center",
  },
  { name: "is_sent", label: "1C", align: "center" },
  { name: "certificate_urls", label: "Сертификаты", align: "center" },
];

/** Документы ПТО (pre_call): без подписей, статуса подписи и 1С */
export const entranceDocumentPtoColumns = [
  {
    name: "floor_map_document_id",
    label: "ID документа",
    field: "floor_map_document_id",
    align: "center",
  },
  {
    name: "floor_map_document_type_name",
    label: "Тип документа",
    field: "floor_map_document_type_name",
    align: "left",
  },
  {
    name: "work_set_check_group_name",
    label: "Группа работ",
    field: "work_set_check_group_name",
    align: "left",
  },
  {
    name: "placement_type_name",
    label: "Тип",
    field: "placement_type_name",
    align: "left",
  },
  {
    name: "block_name",
    label: "Блок",
    field: "block_name",
    align: "center",
  },
  {
    name: "floor",
    label: "Этаж",
    field: "floor",
    align: "center",
  },
  {
    name: "date_create",
    label: "Дата создания",
    field: "date_create",
    align: "center",
  },
  {
    name: "pto_acceptance",
    label: "Принятие ПТО",
    field: "pto_acceptance",
    align: "center",
  },
  {
    name: "download",
    label: "Документ",
    align: "center",
  },
  {
    name: "pto_accept_one",
    label: " ",
    align: "center",
  },
];

/** Колонки для страницы «Документы ПТО» (все проекты): ЖК/проект/подъезд + entranceDocumentPtoColumns */
export const ptoDocumentsSessionLocationColumns = [
  {
    name: "resident_name",
    label: "ЖК",
    field: "resident_name",
    align: "left",
  },
  {
    name: "project_name",
    label: "Проект",
    field: "project_name",
    align: "left",
  },
];

export const residentFinanceInfoColumns = [
  {
    name: "entrance",
    label: "Подъезд",
    field: "entrance",
    align: "center",
  },
  {
    name: "total_sum",
    label: "Общая сумма",
    field: "total_sum",
    align: "right",
  },
  {
    name: "paid_sum",
    label: "Оплаченная сумма",
    field: "paid_sum",
    align: "right",
  },
  {
    name: "processing_sum",
    label: "Ожидается оплата",
    field: "processing_sum",
    align: "right",
  },
  {
    name: "remaining_sum",
    label: "Остаток",
    field: "remaining_sum",
    align: "right",
  },
];

export const residentDocumentsInfoColumns = [
  {
    name: "project_agreement_id",
    label: "ID",
    field: "project_agreement_id",
    align: "center",
  },
  {
    name: "doc_name",
    label: "Наименование",
    field: "doc_name",
    align: "left",
  },
  {
    name: "project_head_name",
    label: "Заказчик",
    field: "project_head_name",
    align: "left",
  },
  {
    name: "contractor_name",
    label: "Подрядчик",
    field: "contractor_name",
    align: "left",
  },
  {
    name: "is_signed",
    label: "Документ",
    field: "is_signed",
    align: "center",
  },
];

export const otherDocumentsInfoColumns = [
  {
    name: "project_agreement_id",
    label: "ID",
    field: "project_agreement_id",
    align: "center",
  },
  {
    name: "doc_name",
    label: "Наименование",
    field: "doc_name",
    align: "left",
  },
  {
    name: "project_head_name",
    label: "Подписанты",
    field: "project_head_name",
    align: "center",
  },
  {
    name: "is_signed",
    label: "Документ",
    field: "is_signed",
    align: "center",
  },
  {
    name: "is_sent",
    label: "1C",
    field: "is_sent",
    align: "center",
  },
];

export const residentDocumentsInfoColumns1C = [
  ...residentDocumentsInfoColumns,
  { name: "is_sent", label: "1C", align: "center" },
];

export const residentResponsibilitiesColumns = [
  {
    name: "contractor_name",
    label: "Организация",
    align: "left",
  },
  {
    name: "assign_type_name",
    label: "Должность",
    align: "left",
  },
  {
    name: "paid_sum",
    label: "ФИО",
    align: "left",
  },
];

export const signersColumns = [
  {
    name: "assign_type_name",
    label: "Должность",
    align: "left",
  },
  {
    name: "fio",
    label: "ФИО",
    align: "left",
  },
  {
    name: "assign_type_name",
    label: "Номер телефона",
    align: "left",
  },
  {
    name: "sign_date",
    label: "Дата подписания",
    align: "center",
  },
  {
    name: "assign_type_name",
    label: "Подписан",
    align: "center",
  },
];

export const getStagesBadgeColor = (code) => {
  switch (code) {
    case "DONE":
      return "green";
    case "DEFECT":
      return "red";
    case "PROCESSING":
      return "primary";
    default:
      return "orange";
  }
};

export const materialCertificatesColumns = [
  {
    name: "material_name",
    label: "Материал",
    field: "material_name",
    align: "left",
  },
  {
    name: "certificate_number",
    label: "№ сертификата",
    field: "certificate_number",
    align: "center",
  },
  {
    name: "document",
    label: "Документ",
    align: "center",
  },
  {
    name: "date_begin",
    label: "Дата начала",
    field: "date_begin",
    align: "center",
  },
  {
    name: "date_end",
    label: "Дата окончания",
    field: "date_end",
    align: "center",
  },
];

export const getProjectMaterialCertificates = async (project_id) => {
  if (!project_id) return [];
  try {
    const res = await residentialSettingsAPI.getProjectMaterialCertificates({
      project_id,
    });
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const modifyProjectMaterialCertificate = async (project_id, body) => {
  if (!project_id || !body) return null;

  const formData = new FormData();
  Object.entries(body).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    formData.append(key, value);
  });

  try {
    const res = await residentialSettingsAPI.modifyProjectMaterialCertificate(
      formData,
      { project_id }
    );
    return res;
  } catch (e) {}
};

export const deleteProjectMaterialCertificate = async (
  project_id,
  project_material_certificate_id
) => {
  if (!project_id || !project_material_certificate_id) return null;
  const params = { project_id, project_material_certificate_id };
  try {
    const res = await residentialSettingsAPI.deleteProjectMaterialCertificate(
      params
    );
    return res;
  } catch (e) {}
};

export const laboratoryActsColumns = [
  {
    name: "laboratory_act_name",
    label: "Название",
    field: "laboratory_act_name",
    align: "left",
  },
  {
    name: "level_num",
    label: "Этаж",
    field: "level_num",
    align: "right",
  },
  {
    name: "placement_type_name",
    label: "Тип помещения",
    field: "placement_type_name",
    align: "left",
  },
  {
    name: "work_set_check_group_name",
    label: "Группа работ",
    field: "work_set_check_group_name",
    align: "left",
  },
  {
    name: "document",
    label: "Документ",
    align: "center",
  },
];

export const getProjectLaboratoryActs = async (project_id) => {
  if (!project_id) return [];
  try {
    const res = await residentialSettingsAPI.getProjectLaboratoryActs({
      project_id,
    });
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const createProjectLaboratoryAct = async (project_id, body, queryParams = {}) => {
  if (!project_id || !body) return null;

  const formData = new FormData();
  Object.entries(body).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    formData.append(key, value);
  });

  try {
    const res = await residentialSettingsAPI.createProjectLaboratoryAct(formData, {
      ...queryParams,
      project_id,
    });
    return res;
  } catch (e) {}
};

export const updateProjectLaboratoryAct = async (project_id, body) => {
  if (!project_id || !body) return null;

  const formData = new FormData();
  Object.entries(body).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    formData.append(key, value);
  });

  try {
    const res = await residentialSettingsAPI.updateProjectLaboratoryAct(
      formData,
      { project_id }
    );
    return res;
  } catch (e) {}
};

export const deleteProjectLaboratoryAct = async (
  project_id,
  project_laboratory_act_id
) => {
  if (!project_id || !project_laboratory_act_id) return null;
  const params = { project_id, project_laboratory_act_id };
  try {
    const res = await residentialSettingsAPI.deleteProjectLaboratoryAct(params);
    return res;
  } catch (e) {}
};

export const getProjectReconciliation = async (body) => {
  try {
    const res = await residentialSettingsAPI.getProjectReconciliation(body);
    return res || null;
  } catch (e) {}
};

export const batchCreateDocuments = async (document_ids, params) => {
  try {
    const body = {
      document_ids,
      resident_id: params.resident_id,
      project_type_id: params.project_type_id,
      project_entrance_id: params.project_entrance_id,
      project_id: params.project_id,
    };
    const res = await residentialSettingsAPI.batchCreateDocuments(body);
    // API возвращает {status: true, error: null, data: "sign_url"}
    const signUrl = res?.data;
    if (!signUrl || typeof signUrl !== "string") {
      throw new Error("Не получен URL для подписания");
    }
    return signUrl;
  } catch (e) {
    throw e;
  }
};

export const getManualAvrCalls = async (project_id) => {
  try {
    const res = await residentialSettingsAPI.getManualAvrCalls(project_id);
    return res;
  } catch (e) {
    return null;
  }
};

export const getManualAvrMaterials = async (help_call_ids) => {
  try {
    const res = await residentialSettingsAPI.getManualAvrMaterials(help_call_ids);
    return res;
  } catch (e) {
    return null;
  }
};

export const createManualAvr = async (help_call_ids) => {
  try {
    const res = await residentialSettingsAPI.createManualAvr(help_call_ids);
    return res;
  } catch (e) {
    throw e;
  }
};

export const createFollowupFromK2sv = async (floor_map_document_id) => {
  try {
    const res = await residentialSettingsAPI.createFollowupFromK2sv(floor_map_document_id);
    return res;
  } catch (e) {
    throw e;
  }
};

export const uploadBuhAvrManualSign = async ({ floor_map_document_id, file, sign_date, params }) => {
  return residentialSettingsAPI.uploadBuhAvrManualSign({
    floor_map_document_id,
    file,
    sign_date,
    params,
  });
};

export const getManualDocumentTypes = async () => {
  try {
    const res = await residentialSettingsAPI.getManualDocumentTypes();
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getM19OverWbs = async (resident_id, project_type_id, sbs_sklad_id = undefined) => {
  try {
    const res = await residentialSettingsAPI.getM19OverWbs(resident_id, project_type_id, sbs_sklad_id);
    return res;
  } catch (e) {
    return null;
  }
};

export const getM19OverSkladOptions = async (project_id) => {
  try {
    return await residentialSettingsAPI.getM19OverSkladOptions(project_id);
  } catch (e) {
    return null;
  }
};

export const previewM19OverWarehouseBalances = async (
  project_id,
  material_ids,
  sbs_sklad_id,
) => {
  try {
    return await residentialSettingsAPI.previewM19OverWarehouseBalances(
      project_id,
      material_ids,
      sbs_sklad_id,
    );
  } catch (e) {
    return null;
  }
};

export const createM19Over = async (project_id, materials, sbs_sklad_id) => {
  try {
    const res = await residentialSettingsAPI.createM19Over(project_id, materials, sbs_sklad_id);
    return res;
  } catch (e) {
    return null;
  }
};

export const deleteM19Over = async (material_overuse_id) => {
  return await residentialSettingsAPI.deleteM19Over(material_overuse_id);
};

export const downloadM19OverPreview = async (project_id, materials) => {
  try {
    const response = await residentialSettingsAPI.previewM19Over(project_id, materials);
    const { saveAs } = await import("file-saver");
    const blob = new Blob([response.data], { type: "application/pdf" });
    const filename = `M19_перерасход_предпросмотр_${new Date().toLocaleDateString("ru")}.pdf`;
    saveAs(blob, filename);
    return true;
  } catch (e) {
    throw e;
  }
};

export const downloadMaterialOveruseReport = async (project_id) => {
  try {
    const response = await residentialSettingsAPI.getMaterialOveruseReport(project_id);
    const { saveAs } = await import("file-saver");
    const blob = new Blob([response.data], { type: "application/pdf" });
    const filename = `Отчёт_смета_vs_списание_${new Date().toLocaleDateString("ru")}.pdf`;
    saveAs(blob, filename);
    return { success: true };
  } catch (e) {
    const blob = e?.response?.data;
    if (blob instanceof Blob) {
      try {
        const text = await blob.text();
        const data = JSON.parse(text);
        return { success: false, message: data.error || "Ошибка при формировании отчёта" };
      } catch {}
    }
    return null;
  }
};

export const downloadManualPreview = async (help_call_ids, doc_status_code, doc_type_name) => {
  try {
    const response = await residentialSettingsAPI.downloadManualPreview(help_call_ids, doc_status_code);
    const { saveAs } = await import("file-saver");
    const blob = new Blob([response.data], { type: "application/pdf" });
    const filename = `${doc_type_name || doc_status_code}_${new Date().toLocaleDateString("ru")}.pdf`;
    saveAs(blob, filename);
    return true;
  } catch (e) {
    throw e;
  }
};

/**
 * Предпросмотр КС2В (и др. manual preview): PDF в новой вкладке.
 * Вкладку нужно открыть синхронно из обработчика клика (window.open до await / реактивных
 * обновлений) и передать сюда как previewWindow — иначе браузер блокирует всплывающее окно
 * или запрещает opener менять location у окна с noopener.
 */
export const openManualPreviewInTab = async (
  help_call_ids,
  doc_status_code,
  previewWindow = null
) => {
  const tab =
    previewWindow && typeof previewWindow.location !== "undefined"
      ? previewWindow
      : window.open("about:blank", "_blank");
  if (!tab) {
    throw new Error("Разрешите всплывающие окна для этого сайта, чтобы открыть предпросмотр.");
  }
  try {
    const response = await residentialSettingsAPI.downloadManualPreview(help_call_ids, doc_status_code);
    const raw = response?.data;
    const blob = raw instanceof Blob ? raw : new Blob([raw], { type: "application/pdf" });
    const buf = await blob.slice(0, 4).arrayBuffer();
    const sig = String.fromCharCode.apply(null, new Uint8Array(buf));
    if (sig !== "%PDF") {
      const text = await blob.text();
      let msg = "Ошибка предпросмотра";
      try {
        const j = JSON.parse(text);
        msg = j.message || j.error || j.detail || msg;
      } catch {
        msg = text.slice(0, 300) || msg;
      }
      throw new Error(msg);
    }
    const url = URL.createObjectURL(blob);
    tab.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 300000);
    return true;
  } catch (e) {
    try {
      tab.close();
    } catch {
      /* ignore */
    }
    const respData = e?.response?.data;
    if (respData instanceof Blob) {
      try {
        const t = await respData.text();
        const j = JSON.parse(t);
        throw new Error(j.message || j.error || e.message || "Ошибка предпросмотра");
      } catch (inner) {
        if (inner instanceof Error && inner.message) throw inner;
      }
    }
    throw e;
  }
};